import { render } from "./QuranAyatCard.vue?vue&type=template&id=0bc4847a"
import script from "./QuranAyatCard.vue?vue&type=script&lang=js"
export * from "./QuranAyatCard.vue?vue&type=script&lang=js"
script.render = render

export default script